// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"189":"30cfa2c4692070ad75aa","404":"3ab9bbf2c686df84d7d4","406":"938f302a71bbb696ef89","485":"ca5a347be4f695f2d1f4"}[chunkId] + ".js";
};